const qs = require('query-string');

function getQueryParams(queryString) {
    return qs.parse(queryString);
}

export {getQueryParams};
